import createAction from '../../services/create-action';
import { setValue } from '../../services/wix-data';
export const SET_WIX_DATA_REQUEST = 'wixData/SET_REQUEST';
export const SET_WIX_DATA_SUCCESS = 'wixData/SET_SUCCESS';
export const SET_WIX_DATA_FAILURE = 'wixData/SET_FAILURE';
export const setWixDataRequest = createAction(SET_WIX_DATA_REQUEST);
export const setWixDataSuccess = createAction(SET_WIX_DATA_SUCCESS, (payload) => payload, (payload, meta) => meta);
export const setWixDataFailure = createAction(SET_WIX_DATA_FAILURE);
export const setWixData = (Wix, key, value, type) => (dispatch) => {
    dispatch(setWixDataRequest({ [key]: value }));
    return setValue(Wix, key, value)
        .then((response) => dispatch(setWixDataSuccess(response, type)))
        .catch((error) => dispatch(setWixDataFailure(error)));
};
//# sourceMappingURL=set-wix-data.js.map